import { useAuth } from '@clerk/react-router'
import { Button } from '../../../core'

export function AuthSplashSignOutButton() {
  const { signOut } = useAuth()

  return (
    <div className="absolute top-4 right-4 z-10">
      <Button
        colorVariant="destructive"
        size="sm"
        variant="ghost"
        onClick={() => {
          void signOut({ redirectUrl: '/sign-in' })
        }}
      >
        {`Sign out`}
      </Button>
    </div>
  )
}
